import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return undefined;
    }
    let tries = 0;
    let timer;
    const attempt = () => {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (tries++ < 40) timer = setTimeout(attempt, 75);
    };
    timer = setTimeout(attempt, 60);
    return () => clearTimeout(timer);
  }, [pathname, hash]);
  return null;
}
